import api from "lib/axios";
import { ApiEnvelope, PaginatedResult, unwrapData, unwrapList } from "./apiTypes";

type Query = Record<string, unknown> | undefined;
type Payload = Record<string, unknown>;

export const moderatorService = {
  async list(params?: Query) {
    const response = await api.get<ApiEnvelope<PaginatedResult<any>>>("/mcp/moderators", {
      params,
      meta: { toastSuccess: false },
    });
    return unwrapList(response.data);
  },
  async show(id: number | string) {
    const response = await api.get<ApiEnvelope<{ data: any }>>(`/mcp/moderators/${id}`, {
      meta: { toastSuccess: false },
    });
    return unwrapData(response.data);
  },
  async create(data: Payload) {
    const response = await api.post<ApiEnvelope<{ data: any }>>("/mcp/moderators", data);
    return unwrapData(response.data);
  },
  async update(id: number | string, data: Payload) {
    const response = await api.put<ApiEnvelope<{ data: any }>>(
      `/mcp/moderators/${id}`,
      data
    );
    return unwrapData(response.data);
  },
  async delete(id: number | string) {
    const response = await api.delete(`/mcp/moderators/${id}`);
    return response.data;
  },
};

